import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProtectedRoute() {
  const { isAuthenticated, token } = useSelector((state) => state.auth);

  // Not logged in → redirect to login
  if (!isAuthenticated || !token) {
    return <Navigate to="/" replace />;
  }

  // Logged in → allow access
  return <Outlet />;
}
